export default "__VITE_ASSET__CdgpyPzJ__"